require('../../modules/es.object.freeze');
var path = require('../../internals/path');

module.exports = path.Object.freeze;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/object/freeze.js
// module id = 626
// module chunks = 0 1